import { generateDataTable, generateHtml } from '../../report-common';

export default {
  data() {
    return {
      isSelect: false,
    };
  },
  props: ['option', 'componentSelect', 'index', 'bodyLength', 'selectedHeading', 'detailReport'],
  watch: {
    componentSelect(n) {
      if (n === this.option.type) this.isSelect = true;
      else this.isSelect = false;
    },
    selectedHeading(newHeading) {
      this.isSelect = this.index === newHeading;
    },
  },
  render(createElement) {
    const self = this;
    if (self?.option?.elements?.length) {
      let subTitleIndex = 0;
      const classes = ['go-report-section'];
      if (self.isSelect && self.detailReport) classes.push('component_select active');
      if (self.index === 0) classes.push('introduction');
      if (self.index === self.bodyLength - 1) classes.push('conclusion');
      return createElement(
        'div',
        {
          class: [
            classes,
            // self.isSelect ?
            // "active" : ""
          ],
          on: {
            click() {
              if (self.index >= 0 && self.detailReport) {
                self.isSelect = true;
                // self.$emit(
                //   'selectBody',
                //   self.option.componentId || self.option.component_id,
                //   self.option?.reference_docIds || self.option?.reference_doc_id,
                // );
                self.$emit('updateSelectedIndex', self.index);
                self?.option?.elements.filter(item => {
                  if (item.elementType == 'heading') {
                    self.$emit(
                      'selectBody',
                      self.option.componentId || self.option.component_id,
                      self.option?.reference_docIds || self.option?.reference_doc_id,
                      `${self.index + 1}. ${item.content || ''}`
                    );
                  } else if (item.elementType == 'heading_without_no') {
                    self.$emit(
                      'selectBody',
                      self.option.componentId || self.option.component_id,
                      self.option?.reference_docIds || self.option?.reference_doc_id,
                      `${item.content || ''}`
                    );
                  }
                });
              }
            },
          },
        },
        self?.option?.elements.map(function (item) {
          switch (item.elementType || item.element_type) {
            case 'bold_text':
              return createElement(
                'b',
                {
                  style: {
                    // listStyleType: 'unset',
                    // listStylePosition: '1rem',
                    display: 'inline-block',
                    marginLeft: '1rem',
                    marginTop: '1rem',
                  },
                },
                `${item.content || ''}`
              );
            case 'bullet_lst':
              if (item.content) {
                // subTitleIndex++;
                return createElement(
                  'ul',
                  {
                    style: {
                      listStyleType: 'unset',
                      listStylePosition: 'inside',
                      marginLeft: '1rem',
                    },
                  },
                  [
                    // createElement('ul', [
                    createElement(
                      'li',
                      {
                        class: [''],
                      },
                      `  ${item.content || ''}`
                    ),
                    // ]),
                  ]
                );
              }
              break;
            case 'heading':
              return createElement(
                'h2',
                {
                  class: [''],
                },
                [
                  `${self.index + 1}. ${item.content || ''}`,
                  self.detailReport
                    ? createElement(
                        'span',
                        {
                          class: self.isSelect ? ['go-help-text', 'hidden'] : ['go-help-text'],
                        },
                        self.$t('report.report-content.select-section')
                      )
                    : null,
                ]
              );
            case 'heading_without_no':
              return createElement(
                'h2',
                {
                  class: [''],
                },
                [
                  `${item.content || ''}`,
                  self.detailReport
                    ? createElement(
                        'span',
                        {
                          class: self.isSelect ? ['go-help-text', 'hidden'] : ['go-help-text'],
                        },
                        self.$t('report.report-content.select-section')
                      )
                    : null,
                ]
              );
            case 'subheading':
              if (item.content) {
                subTitleIndex++;
                return createElement('ul', { class: ['go-report-list-decimal'] }, [
                  createElement('li', [
                    createElement(
                      'h3',
                      {
                        class: [],
                      },
                      `${self.index + 1}-${subTitleIndex}. ${item.content || ''}`
                    ),
                  ]),
                ]);
              }
              break;
            case 'subheading_without_no':
              if (item.content) {
                return createElement('ul', { class: ['go-report-list-decimal'] }, [
                  createElement('li', [
                    createElement(
                      'h3',
                      {
                        class: [],
                      },
                      `${item.content || ''}`
                    ),
                  ]),
                ]);
              }
              break;
            case 'list':
              if (item.content?.length > 0) {
                return createElement(
                  'ul',
                  { class: ['go-report-list-decimal'] },
                  item.content.map(function (text) {
                    return [createElement('li', [createElement('p', text || '')])];
                  })
                );
              } else return createElement('div');
            case 'table':
              return createElement('table', {
                style: {
                  marginTop: '1rem',
                  marginLeft: '1rem',
                  width: 'calc(100% - 1rem)',
                },
                domProps: {
                  innerHTML: generateDataTable(item?.content?.schema, item?.content?.data).innerHTML,
                },
              });
            case 'list-of-list':
              if (item.contents?.length > 0) {
                return createElement('div', {
                  domProps: {
                    innerHTML: generateHtml(item?.content).innerHTML,
                  },
                });
              } else return createElement('div');
            case 'grid':
              if (item?.content) {
                return createElement(
                  'div',
                  { class: ['go-card-gird'] },
                  item?.content?.map(function (objs) {
                    return createElement(
                      'div',
                      {
                        class: ['go-gird-item'],
                      },
                      objs.elements.map(function (obj) {
                        switch (obj.element_type || obj.elementType) {
                          case 'subheading':
                            if (obj.element_type || obj.elementType) {
                              if (obj.content) {
                                subTitleIndex++;
                                return createElement('strong', `${obj.content || 'heheheheheeh'}`);
                              }
                              break;
                            } else return createElement('div');

                          case 'paragraph':
                            if (obj) {
                              if (obj.content) {
                                return createElement(
                                  'ul',
                                  {
                                    style: {
                                      listStyleType: 'none',
                                      // color:  localStorage.getItem("theme") === "dark" && 'white',
                                    },
                                  },
                                  obj.content.map(function (text) {
                                    return createElement('li', [createElement('p', text || '')]);
                                  })
                                );
                              }
                              break;
                            } else return createElement('div');
                        }
                      })
                    );
                  })
                );
              } else return createElement('div');
            case '':
              if (item.content?.length > 0) {
                return createElement('div', {
                  domProps: {
                    innerHTML: generateHtml(item?.content).innerHTML,
                  },
                });
              } else return createElement('div');
          }
          if ((item && item?.elementName?.includes('quote')) || item?.element_name?.includes('quote')) {
            switch (item.elementType || item.element_type) {
              case 'block_quote_1':
                if (item?.content) {
                  return createElement(
                    'blockquote',
                    {
                      class: 'go-blockquote style2',
                    },
                    item.content.map(function (obj, index) {
                      if (index === 0) {
                        return createElement(
                          'div',
                          {
                            class: 'go-blockquote-body',
                          },
                          obj
                        );
                      } else {
                        return createElement('div', { class: ['go-blockquote-footer'] }, [
                          createElement('strong', { class: 'go-speaker' }, obj),
                        ]);
                      }
                    })
                  );
                } else return createElement('div');

              case 'block_quote_2':
                if (item?.content) {
                  return createElement(
                    'blockquote',
                    {
                      class: 'go-blockquote style1',
                    },
                    item.content.map(function (obj, index) {
                      if (index === 0) {
                        return createElement(
                          'div',
                          {
                            class: 'go-blockquote-body',
                          },
                          obj
                        );
                      } else {
                        return createElement('div', { class: ['go-blockquote-footer'] }, [
                          createElement('strong', { class: 'go-speaker' }, obj),
                        ]);
                      }
                    })
                  );
                } else return createElement('div');
              case 'block_quote_3':
                if (item?.content) {
                  return createElement(
                    'blockquote',
                    { class: ['go-blockquote style3'] },
                    item.content.map(function (obj, index) {
                      if (index === 0) {
                        return createElement('div', { class: ['go-blockquote-body'] }, obj);
                      } else {
                        return createElement('div', { class: ['go-blockquote-footer'] }, [
                          createElement('strong', { class: 'go-speaker' }, obj),
                        ]);
                      }
                    })
                  );
                } else return createElement('div');
              case 'block_quote':
                if (item?.content) {
                  return createElement(
                    'ul',
                    {
                      style: {
                        marginTop: '1rem',
                        marginLeft: '1rem',
                      },
                    },
                    item.content.map(function (obj) {
                      return createElement(
                        'div',
                        // {
                        //   on: {
                        //     click() {
                        //       self.$root.$emit('select-reference-document', obj.doc_id);
                        //     },
                        //   },
                        // },
                        [
                          createElement(
                            'div',
                            {
                              style: {
                                borderLeft: localStorage.getItem('theme') === 'dark' ? '4px solid white' : '4px solid black',
                                paddingLeft: '20px',
                              },
                            },
                            obj
                          ),
                          // createElement('a', { class: ['go-report-reference-link'] }, `https://goover.ai/detail-feed/${obj.doc_id}`),
                        ]
                      );
                    })
                  );
                } else return createElement('div');
            }
          }
        })
      );
    }
  },
};
